import { Grid, Skeleton } from '@mui/material';

export default function PackageAndUpsellSelectSkeleton() {
  return (
    <>
      <Grid container spacing={2}>
        {[...Array(4)].map((_, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Skeleton variant='rectangular' width='100%' height={118} />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {[...Array(8)].map((_, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Skeleton variant='rectangular' width='100%' height={60} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
